import React, { useEffect, useRef, useState } from "react";
import { IconBaseProps } from "react-icons";
import { FaChevronDown } from "react-icons/fa";
import "./filter.css";
import "../../../../styles/css/custom-select.css";

interface Option {
  key: string;
  value: string;
}

interface FilterProps {
  Icon: React.ComponentType<IconBaseProps>;
  iconSize: number;
  options: Option[];
  filterType: string;
  handleFilter: (e: React.ChangeEvent<HTMLSelectElement>, filterType: string) => void;
  filterValue: string;
}

function Filter({ Icon, iconSize, options, filterType, handleFilter, filterValue }: FilterProps) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onOutsideClick(e: MouseEvent) {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", onOutsideClick);
    return () => document.removeEventListener("mousedown", onOutsideClick);
  }, []);

  const allOptions = [{ key: "", value: "All" }, ...options];
  const selectedLabel = allOptions.find((o) => o.key === filterValue)?.value ?? "All";

  function handleSelect(value: string) {
    const syntheticEvent = { target: { value } } as React.ChangeEvent<HTMLSelectElement>;
    handleFilter(syntheticEvent, filterType);
    setOpen(false);
  }

  return (
    <div className="filter-pill-wrap" ref={wrapRef}>
      <button
        type="button"
        className={`filter-pill ${open ? "filter-pill--open" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <Icon size={iconSize} className="filter-pill__icon" />
        <span className="filter-pill__value">{selectedLabel}</span>
        <FaChevronDown size={11} className={`filter-pill__chevron ${open ? "filter-pill__chevron--up" : ""}`} />
      </button>

      {open && (
        <ul className="custom-select-menu" role="listbox">
          {allOptions.map((option, i) => (
            <li
              key={i}
              role="option"
              aria-selected={option.key === filterValue}
              className={[
                "custom-select-option",
                option.key === filterValue ? "custom-select-option--selected" : "",
              ].join(" ")}
              onClick={() => handleSelect(option.key)}
            >
              {option.value}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Filter;
